import "/__w/1/s/BotFramework-WebChat/packages/bundle/src/adaptiveCards/Attachment/SignInCardContent.module_built.css";
const classes = {"sign-in-card-attachment":"w1mc8QW_sign-in-card-attachment"}
export default classes

const _sign_in_card_attachment0 = classes["sign-in-card-attachment"]
export { _sign_in_card_attachment0 as "sign-in-card-attachment" }
